<template>
    <div class="flex flex-row items-center">
        <div>
            <FormInput type="select"
                       :options="months"
                       v-model="month"
                       autocomplete="cc-exp-month"
                       disable-un-select/>
        </div>
        <div>月</div>
        <div>
            <FormInput type="select"
                       :options="years"
                       v-model="year"
                       autocomplete="cc-exp-year"
                       disable-un-select/>
        </div>
        <div>年</div>
    </div>
</template>

<script>
import moment from "moment";
import FormInput from "./FormInput";

export default {
    name: "CardExpireInput",
    components: {FormInput},

    props: {
        value: {
            type: String
        }
    },

    data() {
        return {
            year: null,
            month: null,
        }
    },

    watch: {
        year: function () {
            this.onUpdate();
        },

        month: function () {
            this.onUpdate();
        },

        value: function () {
            this.onReverse();
        }
    },

    computed: {
        years() {
            const range = (start, end) => [...Array((end - start) + 1)].map((_, i) => start + i);
            const start = parseInt(moment().format('YYYY'));
            const end = parseInt(moment().add(10, 'years').format('YYYY'));
            return range(start, end).map(year => ({
                value: year,
                label: `${year}`.slice(-2),
            }));
        },

        months() {
            const range = (start, end) => [...Array((end - start) + 1)].map((_, i) => start + i);
            return range(1, 12).map(month => ({
                value: `00${month}`.slice(-2),
                label: month,
            }));
        }
    },

    mounted() {
        this.onReverse();
    },

    methods: {
        onUpdate() {
            this.$emit('input', `${this.year}${this.month}`);
        },

        onReverse() {
            if (/^\d{6}$/.test(this.value)) {
                this.year = this.value.slice(0, 4);
                this.month = this.value.slice(-2);
            }
        },
    }
}
</script>

<style scoped>

</style>
